module.exports = __webpack_public_path__ + "img/03.56d2f9f8.jpg";